




// import { Link } from "react-router-dom";
// import { jobIndustries, nigeriaStates, workTypes } from "../assets/jobData";

// function SearchComponent({ handleSearch, handleChange, lgas, cities, handleLgaClick, handleCityClick, state }) {
//   return (
//     <div className="w-full text-sm">
//       <form className="flex flex-wrap sm:w-fit w-full mx-auto sm:my-8 my-4 items-center border-2 border-slate-200 justify-center rounded-lg shadow-md">
//         <div className="px-4 py-4 bg-gray-100 w-full text-center rounded-t-lg">
//           <h3 className="text-lg font-bold text-gray-700">FIND A JOB</h3>
//         </div>
//         <div className="bg-gray-50 px-4 py-4 w-full flex items-center justify-center flex-wrap gap-4 rounded-b-lg">
//           <input
//             onChange={handleChange}
//             name="jobTitle"
//             className="px-3 py-2 border border-gray-300 rounded-lg outline-none focus:border-blue-500 transition"
//             type="text"
//             placeholder="Job function"
//           />

//           <select
//             onChange={handleChange}
//             name="industry"
//             className="px-3 py-2 border border-gray-300 rounded-lg outline-none focus:border-blue-500 transition"
//             placeholder="Any Industry"
//           >
//             <option disabled selected>
//               Industry
//             </option>
//             {[
//               jobIndustries.map((industry) => {
//                 return (
//                   <option key={industry} value={industry}>
//                     {industry}
//                   </option>
//                 );
//               }),
//             ]}
//           </select>

//           <select
//             onChange={handleChange}
//             name="state"
//             className="px-3 py-2 border border-gray-300 rounded-lg outline-none focus:border-blue-500 transition"
//             placeholder="Location: Ikeja, Lagos"
//           >
//             <option disabled selected>
//               State
//             </option>
//             {[
//               nigeriaStates.map((state) => {
//                 return (
//                   <option key={state} value={state}>
//                     {state}
//                   </option>
//                 );
//               }),
//             ]}
//           </select>

//           <select
//             onChange={handleChange}
//             name="workType"
//             className="px-3 py-2 border border-gray-300 rounded-lg outline-none focus:border-blue-500 transition"
//             placeholder="Type: Hybrid"
//           >
//             <option disabled selected>
//               Work type
//             </option>
//             {[
//               workTypes.map((workType) => {
//                 return (
//                   <option key={workType} value={workType}>
//                     {workType}
//                   </option>
//                 );
//               }),
//             ]}
//           </select>

//           <button
//             onClick={handleSearch}
//             className="px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition"
//           >
//             Search
//           </button>
//         </div>
//         {state && (lgas.length > 0 || cities.length > 0) && (
//           <div className="bg-gray-50 px-4 py-2 w-full flex items-center justify-center flex-wrap gap-2 rounded-b-lg">
//             {lgas.length > 0 && (
//               <div className="mr-4">
//                 <h4 className="text-sm font-semibold text-gray-700">Local Governments:</h4>
//                 {lgas.map((lga, index) => (
//                   <button
//                     key={index}
//                     onClick={() => handleLgaClick(lga)}
//                     className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full hover:bg-blue-200 transition mx-1 my-1"
//                   >
//                     {lga}
//                   </button>
//                 ))}
//               </div>
//             )}
//             {cities.length > 0 && (
//               <div>
//                 <h4 className="text-sm font-semibold text-gray-700">Cities:</h4>
//                 {cities.map((city, index) => (
//                   <>
                
//                     <button

//                     key={index}
//                     onClick={() => handleCityClick(city)}
//                     className="px-3 py-1 bg-green-100 text-green-700 rounded-full hover:bg-green-200 transition mx-1 my-1"
//                   >
//                     {city}
//                   </button>

//                   </>
                
//                 ))}
//               </div>
//             )}
//           </div>
//         )}
//       </form>
//     </div>
//   );
// }

// export default SearchComponent;


import { Link } from "react-router-dom";
import { jobIndustries, nigeriaStates, workTypes } from "../assets/jobData";

function SearchComponent({ handleSearch, handleChange, lgas, cities, handleLgaClick, handleCityClick, state, jobCounts }) {
  const handleLocationChange = (value) => {
    if (lgas.includes(value)) {
      handleLgaClick(value);
    } else if (cities.includes(value)) {
      handleCityClick(value);
    }
  };

  return (
    <div className="w-full text-sm">
      <form className="flex flex-wrap sm:w-fit w-full mx-auto sm:my-8 my-4 items-center border-2 border-slate-200 justify-center rounded-lg shadow-md">
        <div className="px-4 py-4 bg-gray-100 w-full text-center rounded-t-lg">
          <h3 className="text-lg font-bold text-gray-700">FIND A JOB</h3>
        </div>
        <div className="bg-gray-50 px-4 py-4 w-full flex items-center justify-center flex-wrap gap-4 rounded-b-lg">
          <input
            onChange={handleChange}
            name="jobTitle"
            className="px-3 py-2 border border-gray-300 rounded-lg outline-none focus:border-blue-500 transition"
            type="text"
            placeholder="Job function"
          />

          <select
            onChange={handleChange}
            name="industry"
            className="px-3 py-2 border border-gray-300 rounded-lg outline-none focus:border-blue-500 transition"
          >
            <option disabled selected>
              Industry
            </option>
            {jobIndustries.map((industry) => (
              <option key={industry} value={industry}>
                {industry}
              </option>
            ))}
          </select>

          <select
            onChange={handleChange}
            name="state"
            className="px-3 py-2 border border-gray-300 rounded-lg outline-none focus:border-blue-500 transition"
          >
            <option disabled selected>
              State
            </option>
            {nigeriaStates.map((state) => (
              <option key={state} value={state}>
                {state}
              </option>
            ))}
          </select>

          <select
            onChange={handleChange}
            name="workType"
            className="px-3 py-2 border border-gray-300 rounded-lg outline-none focus:border-blue-500 transition"
          >
            <option disabled selected>
              Work type
            </option>
            {workTypes.map((workType) => (
              <option key={workType} value={workType}>
                {workType}
              </option>
            ))}
          </select>

          <button
            onClick={handleSearch}
            className="px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition"
          >
            Search
          </button>
        </div>
        {state && (lgas.length > 0 || cities.length > 0) && (
          <div className="bg-gray-50 px-4 py-2 w-full flex flex-col items-center justify-center gap-4 rounded-b-lg">
            <div className="w-full flex flex-wrap justify-center gap-4">
              {lgas.length > 0 && (
                <div className="mr-4">
                  <h4 className="text-sm font-semibold text-gray-700">Local Governments:</h4>
                  <div className="flex flex-wrap gap-2 mt-2">
                    {lgas.map((lga, index) => (
                      <button
                        key={index}
                        onClick={() => handleLgaClick(lga)}
                        className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full hover:bg-blue-200 transition mx-1 my-1"
                      >
                        {lga}
                      </button>
                    ))}
                  </div>
                </div>
              )}
              {cities.length > 0 && (
                <div className="flex items-start gap-4">
                  <div>
                    <h4 className="text-sm font-semibold text-gray-700">Cities:</h4>
                    <div className="flex flex-wrap gap-2 mt-2">
                      {cities.map((city, index) => (
                        <button
                          key={index}
                          onClick={() => handleCityClick(city)}
                          className="px-3 py-1 bg-green-100 text-green-700 rounded-full hover:bg-green-200 transition mx-1 my-1"
                        >
                          {city}
                        </button>
                      ))}
                    </div>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-gray-700"></h4>
                    {jobCounts.lgas || jobCounts.cities ? (
                      <select
                        onChange={(e) => handleLocationChange(e.target.value)}
                        className="mt-2 px-3 py-2 border-2 border-orange-400 rounded-lg outline-none focus:border-orange-600 transition w-full max-w-xs"
                      >
                        <option disabled selected>
                          Towns
                        </option>
                        {lgas.map((lga) => (
                          <option key={`lga-${lga}`} value={lga}>
                            {lga} (LGA, {jobCounts.lgas[lga] || 0} jobs)
                          </option>
                        ))}
                        {cities.map((city) => (
                          <option key={`city-${city}`} value={city}>
                            {city} (City, {jobCounts.cities[city] || 0} jobs)
                          </option>
                        ))}
                      </select>
                    ) : (
                      <p className="mt-2 text-gray-500">Loading locations...</p>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </form>
    </div>
  );
}

export default SearchComponent;